import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../../common/Loading';
import { useGetTournament } from '../../../hooks/useGetTournament';
import PageContainer from '../../common/PageContainer';
import TimeChain from '../../TimeChain';
import DateRangeRadio from '../../common/DateRangeRadio';
import {
  ArbitratorContainer,
  DateTitle,
  Description,
  HeaderContainer,
  TableContainer,
  Title,
} from './styles';
import ArbitratorsChain from '../ArbitratorsChain';
import ScheduleList from '../ScheduleList';
import { formatDate } from '../../../utils/date';

type TTornamentPage = {
  menuTitle: string;
  menuHref: string;
};

const TournamentPage = ({ menuHref, menuTitle }: TTornamentPage) => {
  const params = useParams();

  const tourId = params.id;

  const { isError, data, isLoading } = useGetTournament(tourId);

  const [selectDate, setSelectDate] = useState('');
  const [selectIndex, setSelectIndex] = useState(0);

  useEffect(() => {
    if (data && data.date_start) {
      setSelectDate(formatDate(new Date(data.date_start)));
    }
  }, [data]);

  if (isLoading) return <Loading />;

  if (isError || !data) return <>Error</>;

  const menuLinks = [
    {
      title: menuTitle,
      href: menuHref,
    },
    {
      title: data.name,
    },
  ];

  const lang = data.language.code;

  const onDateRangeChange = (value: string, index: number) => {
    setSelectDate(value);
    setSelectIndex(index);
  };

  return (
    <PageContainer menuLinks={menuLinks} isWide={true}>
      <HeaderContainer>
        <Description>
          {lang == 'ru' ? 'Турнирная таблица' : 'Competition timeline'}
        </Description>
        <Title>{data.name}</Title>
        <TimeChain
          startDate={data.date_start}
          endDate={data.date_end}
          time={data.start_time}
          lang={lang}
        />
        <DateRangeRadio
          dateStart={data.date_start}
          dateEnd={data.date_end}
          value={selectDate}
          onChange={onDateRangeChange}
        />
      </HeaderContainer>
      <TableContainer>
        <ArbitratorContainer>
          <DateTitle>{selectDate}</DateTitle>
          <ArbitratorsChain
            chief={data.chief_arbitrator}
            other={data.arbitrators}
            lang={lang}
          />
        </ArbitratorContainer>
        <ScheduleList
          scheduleItems={data.days[selectIndex].schedule_items}
          competitionType={data.competition_type}
          lang={lang}
          rounds={data.rounds}
        />
      </TableContainer>
    </PageContainer>
  );
};

export default TournamentPage;
